<template>
    <div class="text-center" v-if="success">
        Sporočilo je bilo poslano.
    </div>
    <form @submit.prevent="submit" v-else>
        <div class="form-group">
            <label for="name">Ime in priimek <span>*</span></label>
            <input type="text" class="form-control" name="name" id="name" v-model="fields.name" />
            <div v-if="errors && errors.name" class="text-danger">{{ errors.name[0] }}</div>
        </div>
        <div class="form-group">
            <label for="email">E-mail <span>*</span></label>
            <input type="email" class="form-control" name="email" id="email" v-model="fields.email" />
            <div v-if="errors && errors.email" class="text-danger">{{ errors.email[0] }}</div>
        </div>
        <div class="form-group">
            <label for="message">Sporočilo <span>*</span></label>
            <textarea class="form-control" id="message" name="message" v-model="fields.message"></textarea>
            <div v-if="errors && errors.message" class="text-danger">{{ errors.message[0] }}</div>
        </div>
        <div class="form-group">
            <div class="checkbox">
                <label>
                    <input name="policy" id="policy" v-model="fields.policy" value="1" type="checkbox" />
                    <div>Strinjam se s Politiko zasebnosti <span>*</span></div>
                </label>
            </div>
            <div v-if="errors && errors.policy" class="text-danger">{{ errors.policy[0] }}</div>
        </div>
        <button type="submit" class="btn btn-primary">Pošlji</button>
    </form>
</template>

<script>
export default {
  data() {
    return {
      fields: {},
      errors: {},
      success: false,
    }
  },
  methods: {
    submit() {
      this.errors = {};
      axios.post('/submit', this.fields).then(response => {
        this.success = true;
      }).catch(error => {
        if (error.response.status === 422) {
          this.errors = error.response.data.errors || {};
        }
      });
    },
  },
}
</script>